import { useSelector } from 'react-redux';
import { ROLES } from 'Constants/roles';
const useIsLearningRMCH = () => {
  const user = useSelector((state) => state.authSlice?.userData);
  let isRM = false;
  let isCH = false;
  if (user?.learningRoles?.includes(ROLES.RM)) {
    isRM = true;
  }
  if (user?.learningRoles?.includes(ROLES.CH)) {
    isCH = true;
  }
  return { isRM, isCH };
};

export default useIsLearningRMCH;
// example usage
